import React from 'react';

function Hero({ query, setQuery, minYear, setMinYear, onSearch, onKeyDown }) {
  return (
    <section className="hero">
      <div className="hero-text">
        <h1>
          Discover Your Next <span className="accent">Obsession</span>
        </h1>
        <p>
          Search thousands of anime titles. Get ratings, plot summaries,
          and more — powered by OMDB.
        </p>

        <div className="search-bar">
          <input
            type="text"
            placeholder="Search anime... e.g. Naruto, Attack on Titan"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onKeyDown={onKeyDown}
          />
          <button onClick={onSearch}>Search</button>
        </div>

        <div className="hero-filters">
          <label htmlFor="yearSlider">Min Year:</label>
          <input
            id="yearSlider"
            type="range"
            min="1980"
            max="2024"
            step="1"
            value={minYear}
            onChange={(e) => setMinYear(parseInt(e.target.value))}
          />
          <span className="year-val">{minYear}</span>
        </div>
      </div>

      <div className="hero-illustration">
        <video
  src={`${process.env.PUBLIC_URL}/fight.mp4`}
  autoPlay
  loop
  muted
  playsInline
  className="fight-video"
/>
      </div>
    </section>
  );
}

export default Hero;